import { twMerge } from 'tailwind-merge';

/** Łączy klasy i scala kolizje utilities Tailwinda (ostatnia wygrywa), pomijając wartości puste. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return twMerge(parts.filter(Boolean).join(' '));
}
